const Fortress = window.cccisd.fortress;

const { role = {}, group = {}, id } = Fortress.user.acting;
const roleHandle = role.handle || null;
const groupId = group ? group.id : null;
const pawnId = id || null;

export function getPermissions() {
    if (roleHandle === 'instructor') {
        return ['group.assessment_manager', 'rostering.group.*'];
    }
    if (roleHandle === 'orgAdmin' || roleHandle === 'uberadmin') {
        return null;
    }

    return ['group.assessment_manager'];
}

export function getPermissionFilter() {
    if (roleHandle === 'siteAdmin') {
        return {
            eq: {
                field: 'parentGroup.site.group.groupId',
                int: groupId,
            },
        };
    }
    if (roleHandle === 'orgAdmin' || roleHandle === 'uberadmin') {
        return null;
    }

    return {
        AND: [
            {
                eq: {
                    field: 'targetPermission.pawn.pawn.pawnId',
                    int: pawnId,
                },
            },
            { notNull: { field: 'targetPermission.permission' } },
        ],
    };
}
